var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61878",
    "data-name": "Group 61878",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22922",
    "data-name": "Rectangle 22922",
    width: 42,
    height: 42,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61878-2",
    "data-name": "Group 61878",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82392",
    "data-name": "Path 82392",
    d: "M13.926,8.979A5.376,5.376,0,1,1,8.55,14.355a5.376,5.376,0,0,1,5.376-5.376",
    fill: "#ea2a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82393",
    "data-name": "Path 82393",
    d: "M29.261,8.979a5.376,5.376,0,1,1-5.376,5.376,5.376,5.376,0,0,1,5.376-5.376",
    fill: "#ea2a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82394",
    "data-name": "Path 82394",
    d: "M23.184,34.609a1.087,1.087,0,0,1-.18.01c-1.61-.01-3.6-.01-5.71-.01h-12a3.31,3.31,0,0,1-3.09-4.49,12.766,12.766,0,0,1,23.89.01,3.305,3.305,0,0,1-2.91,4.48",
    fill: "#ea2a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82395",
    "data-name": "Path 82395",
    d: "M36,34.619c-1.6-.007-3.551-.009-5.632-.01A1.215,1.215,0,0,1,29.2,33.03a3.827,3.827,0,0,0-.068-2.581,15,15,0,0,0-4.48-6.261A1.232,1.232,0,0,1,25.214,22a12.775,12.775,0,0,1,13.88,8.124A3.31,3.31,0,0,1,36,34.619",
    fill: "#ea2a8a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractStaff);
export default __webpack_public_path__ + "static/media/contract-staff.8a47c7ed36401056590b19f23cfd4b42.svg";
export { ForwardRef as ReactComponent };